// extracted by mini-css-extract-plugin
export default {"container":"FrequentlyAskedQuestions_container__dUf-D","header":"FrequentlyAskedQuestions_header__bciWI","logo":"FrequentlyAskedQuestions_logo__gZSEp"};